import React from "react";
import styled from "styled-components";
import { Link } from "wouter";
import theme from "../theme";
import Card from "./Card";

const Head = styled(Card)`
  text-align: center;

  margin: ${theme.margin}rem auto;

  h1 {
    font-size: 1.5rem;

    @media only screen and (min-width: 992px) {
      font-size: 3rem;
    }

    margin-bottom: ${theme.margin}rem;
  }

  hr {
    background-color: ${theme.lightGray};
    height: 1px;
    border: none;
    width: 80%;
  }
`;

const Links = styled.nav`
  margin-top: ${theme.margin - 1}rem;

  > * {
    font-size: 1.2rem;
    text-transform: uppercase;

    a {
      color: ${theme.text};

      &:hover {
        color: ${theme.accent};
      }
    }
  }

  > * + * {
    &:before {
      content: "|";
      color: ${theme.lightGray};

      margin: 0 0.75rem;
    }
  }
`;

const Header = () => {
  return (
    <Head>
      <h1>Prismanetwork</h1>

      <hr />

      <Links>
        <span>
          <Link href="/">Home</Link>
        </span>

        <span>
          <Link href="/data">Statistiche</Link>
        </span>

        <span>
          <Link href="/spinoff">Spinoff</Link>
        </span>
      </Links>
    </Head>
  );
};

export default Header;
